<template>
  <AppHeaderDrawer>
    <div class="the-header">
      <div class="the-header__main">
        <div class="container">
          <div class="the-header__content">
            <div class="the-header__content-bottom">
              <template v-if="$core.breakpoint.xlOnly">
                <TheHeaderNav :items="nav" />
              </template>
              <template v-if="$core.breakpoint.lgAndDown">
                <TheHeaderBurger @click="$emit('toggleMenu')" />
                <div class="spacer"></div>
              </template>
              <AuthManager />
            </div>
            <AppBreadcrumbs
              v-if="$core.breakpoint.lgAndUp"
              class="the-header__breadcrumbs"
            />
          </div>
        </div>
      </div>
    </div>
  </AppHeaderDrawer>
</template>

<script>
import AppHeaderDrawer from "@/components/ui/app/AppHeaderDrawer";
import TheHeaderNav from "./TheHeaderNav";
import TheHeaderBurger from "./TheHeaderBurger";
import { AppBreadcrumbs } from "@/components/common/breadcrumbs/";
import AuthManager from "@/components/profile/auth/AuthManager";

export default {
  name: "TheHeader",
  components: {
    AppHeaderDrawer,
    TheHeaderNav,
    TheHeaderBurger,
    AppBreadcrumbs,
    AuthManager
  },
  props: {
    nav: Array
  },
  computed: {
    showSideBars() {
      return this.$core.breakpoint.width < 1260;
    }
  }
};
</script>

<style lang="scss">
.the-header {
  width: 100%;
  position: relative;

  &__main {
    background: url("~@/assets/images/other/header-bg.png") 50% 0 no-repeat;
    height: 110px;
  }

  &__content {
    position: relative;
    padding-top: 15px;
  }

  &__content-bottom {
    display: flex;
    align-items: center;
  }

  &__breadcrumbs {
    position: absolute;
    bottom: -55px;
    left: -10px;
  }
}
</style>
